/* eslint-disable
    func-names,
    no-console,
    no-unused-vars,
    no-use-before-define,
    no-var,
    vars-on-top,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const CategorizerUploadRulesCtrl = function (
  $scope,
  ngDialog,
  CategorizerRuleCollection,
  NotificationsService,
  blConfirmService,
) {
  const rules = new CategorizerRuleCollection(this.rulesId);

  $scope.$watch('vm.rawFile', (newUpload, prevUpload) => {
    if (newUpload !== prevUpload) {
      return save(newUpload);
    }
  });

  this.onDrop = function ($files, $event, $rejectedFiles) {
    return this.save($files);
  };

  const upload = (rawFile, sendEvent, oldRuleIds) => {
    const file = rules.$post(rawFile);
    NotificationsService.loader({
      resolve: file,
      loadingText: 'Uploading rules...',
      successText: 'Rules sucessfully uploaded!',
      failureText: 'Rules upload failed.',
    })
      .then(res => rules.$fetch())
      .then(res => {
        if (sendEvent) sendHeapEvent(oldRuleIds);
      })
      .catch(res => {
        const { errors } = res.data;
        const groupedErrors = _.groupBy(errors, 'error');
        return this.openRulesNotificationModal(groupedErrors);
      });

    return (this.openRulesNotificationModal = function (ruleErrors = []) {
      if (ruleErrors === {}) {
        return;
      }

      console.log(ruleErrors);

      return ngDialog.open({
        className: 'bl-confirm bl-categorizer-rules-upload-modal',
        data: { ruleErrors },
        template: `\
<div
  class="bl-card_section bl-card_section-padded-medium">
  <p class="notice">No rules have been created due to errors:</p>

  <div class="error-list">
  <ul>
    <li ng-if="ngDialogData.ruleErrors.WrongLedger" ng-repeat="error in ngDialogData.ruleErrors.WrongLedger">
      Ledger <span class="error-value">'{{ error.value }}'</span>
      doesn't exist in <span class="error-value">row {{ error.rowNum }}</span>
    </li>
    <li ng-if="ngDialogData.ruleErrors.EmptyCell" ng-repeat="error in ngDialogData.ruleErrors.EmptyCell">
      Empty <span class="error-value">'{{ error.value }}'</span>
      cell in <span class="error-value">row {{ error.rowNum }}</span>
    </li>
  </ul>
  </div>

</div>
<div class="bl-card_section_bottom">
  <div class="ngdialog-buttons">
    <button
      class="bl-button primary"
      ng-click="closeThisDialog()"
    >Got it!</button>
  </div>
</div>\
`,
      });
    });
  };

  var save = function (file) {
    if (file != null) {
      if (rules.data.length) {
        const openConfirmMessage = `Uploading rules will replace all existing rules. \
Are you sure you want to do that?`;
        return blConfirmService.openConfirm(openConfirmMessage).then(() =>
          upload(
            file,
            true,
            rules.data.map(rule => rule.id),
          ),
        );
      }
      return upload(file, false, []);
    }
  };

  var sendHeapEvent = function (oldRuleIds) {
    if (window.heap) {
      window.heap.track('Client Rule Deleted All By Upload', {
        ruleIds: JSON.stringify(oldRuleIds),
        numOfRulesDeleted: oldRuleIds.length.toString(),
        deleteAt: new Date().toString(),
        action: 'Client Rule Deleted All By Upload',
      });
    }
  };
};

module.exports = CategorizerUploadRulesCtrl;
